export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SPREMIUM_BASE_URL = process.env.REACT_APP_SPREMIUM_BASE_URL;
